import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, ActionPlanPluginService, ActionPlanDataService } from '../../shared/services/index';
import { ActionPlanPlugin } from '../../shared/models/index';

@Injectable()
export class ActionParticipantsPluginService extends ActionPlanPluginService {
  constructor(protected apiService: ApiService, protected actionPlanDataService: ActionPlanDataService) {
    super(apiService, actionPlanDataService);
  }

  public updateParticipants(
    actionPlanId: string,
    actionPlanItemId: string,
    pluginId: string,
    participants: string[]
  ): Observable<any> {
    const url = `/actionplans/${actionPlanId}/actionplanitems/${actionPlanItemId}/plugins/participants/${pluginId}`;
    return this.apiService.post(url, { participants }).pipe(
      map((res: ActionPlanPlugin) => {
        return this.actionPlanDataService.updatePlugin(actionPlanId, res);
      })
    );
  }
}
